import { differenceInMonths, parse } from "date-fns";
import {
    SiNextdotjs,
    SiReact,
    SiPython,
    SiFastapi,
    SiPandas,
    SiTailwindcss,
    SiBootstrap,
    SiGit,
    SiExpress,
    SiFirebase,
    SiPostgresql,
    SiMongodb,
    SiAmazonaws,
    SiMicrosoftazure,
    SiGnubash,
    SiGraphql,
    SiCypress,
    SiJest,
    SiAdobeillustrator,
    SiAdobexd,
    SiFigma,
    SiBlender,
    SiRedux,
    SiMui,
    SiBulma,
    SiNestjs,
    SiDocker,
    SiWebpack,
    SiApollographql,
    SiApacheairflow,
    SiStreamlit,
    SiFlutter,
    SiCelery
} from "react-icons/si"
import { IoLogoNodejs } from "react-icons/io"
import { FaPhp, FaCss3Alt } from "react-icons/fa"
import { GrMysql } from "react-icons/gr"
import { RiReactjsLine, RiVuejsFill, RiJavascriptFill } from "react-icons/ri"
import { FaSass, FaHtml5 } from "react-icons/fa6";
import { BiLogoTypescript } from "react-icons/bi";
import { DiRedis } from "react-icons/di";
import neonLogo from "../assets/neon-logo.svg";


export const getDiffTime = (period) => {
    const [start, end] = period.split(" - ");

    const startDate = parse(start, "MMM yyyy", new Date());
    const endDate = end === "Present" ? new Date() : parse(end, "MMM yyyy", new Date());

    const monthsDifference = differenceInMonths(endDate, startDate);

    let years = Math.floor(monthsDifference / 12);
    let months = (monthsDifference % 12) + 1; // Add 1 extra month

    if (months > 11) {
        years += 1;
        months = 0;
    }

    return { years, months };
};

export const getIcon = (className) => {
    switch (className) {
        case "html":
            return <FaHtml5 />
        case "css":
            return <FaCss3Alt />
        case "js":
        case "javascript":
            return <RiJavascriptFill />
        case "ts":
        case "typescript":
            return <BiLogoTypescript />
        case "next":
        case "nextjs":
            return <SiNextdotjs />
        case "react":
        case "reactjs":
            return <SiReact />
        case "flutter":
            return <SiFlutter />
        case "redux":
            return <SiRedux />
        case "vue":
        case "vuejs":
            return <RiVuejsFill />
        case "react-native":
            return <RiReactjsLine />
        case "py":
        case "python":
            return <SiPython />
        case "fastapi":
            return <SiFastapi />
        case "pandas":
            return <SiPandas />
        case "php":
            return <FaPhp />
        case "mui":
        case "materialui":
            return <SiMui />
        case "bulma":
            return <SiBulma />
        case "sass":
            return <FaSass />
        case "tailwind":
            return <SiTailwindcss />
        case "bootstrap":
            return <SiBootstrap />
        case "git":
            return <SiGit />
        case "firebase":
            return <SiFirebase />
        case "docker":
            return <SiDocker />
        case "aws":
            return <SiAmazonaws />
        case "azure":
            return <SiMicrosoftazure />
        case "bash":
            return <SiGnubash />
        case "mongo":
            return <SiMongodb />
        case "node":
        case "nodejs":
            return <IoLogoNodejs />
        case "express":
        case "expressjs":
            return <SiExpress />
        case "nestjs":
            return <SiNestjs />
        case "graphql":
            return <SiGraphql />
        case "postgres":
            return <SiPostgresql />
        case "mongodb":
            return <SiMongodb />
        case "mysql":
            return <GrMysql />
        case "jest":
            return <SiJest />
        case "cypress":
            return <SiCypress />
        case "redis":
            return <DiRedis />
        case "celery":
            return <SiCelery />
        case "ai":
            return <SiAdobeillustrator />
        case "xd":
            return <SiAdobexd />
        case "figma":
            return <SiFigma />
        case "blender":
            return <SiBlender />
        case "webpack":
            return <SiWebpack />
        case "apollo":
            return <SiApollographql />
        case "airflow":
            return <SiApacheairflow />
        case "neon":
            return <img src={neonLogo} alt="Neon" style={{ width: 25, height: 25 }} />
        case "streamlit":
            return <SiStreamlit />
        default:
            return null
    }
}